import './pages/index.js';
import * as lottie from 'lottie-web';
import animationData from './json/loop.json';

document.addEventListener( 'DOMContentLoaded', function () {
	// お問い合わせフォーム
	setTimeout( () => {
		const urlParams = new URLSearchParams( window.location.search );
		const type = urlParams.get( 'type' );

		const checkboxes = document.querySelectorAll(
			'#jsOption input[type="checkbox"]'
		);
		console.log( 'type', type );

		checkboxes.forEach( ( checkbox ) => {
			switch ( type ) {
				case 'contact':
					if ( checkbox.value === 'お問い合わせ' )
						checkbox.checked = true;
					break;
				case 'demo':
					if ( checkbox.value === '無料デモ' )
						checkbox.checked = true;
					break;
				case 'assessment':
					if ( checkbox.value === '無償アセスメント' )
						checkbox.checked = true;
					break;
			}
		} );
	}, 500 ); // 500ミリ秒待機

	// スムーズスクロールの実装
	document.querySelectorAll( '.scr' ).forEach( ( button ) => {
		button.addEventListener( 'click', function () {
			const targetId = this.getAttribute( 'id' ).replace( 'linkTo', '' );
			const targetElement = document.getElementById( targetId );
			if ( targetElement ) {
				const offsetTop =
					targetElement.getBoundingClientRect().top +
					window.pageYOffset -
					100;
				window.scrollTo( {
					top: offsetTop,
					behavior: 'smooth',
				} );
			}
		} );
	} );

	document.querySelectorAll( '.c-question dl dt' ).forEach( ( dt ) => {
		dt.addEventListener( 'click', function () {
			const dd = this.nextElementSibling;
			if ( dd.style.height === '0px' || dd.style.height === '' ) {
				this.parentNode.classList.add( 'open' );
				const fullHeight = dd.scrollHeight + 'px';
				dd.style.height = fullHeight;
			} else {
				this.parentNode.classList.remove( 'open' );
				dd.style.height = '0px';
			}
		} );
	} );

	// 初期状態で開いているddの高さを設定
	document.querySelectorAll( '.c-question .open dd' ).forEach( ( dd ) => {
		const fullHeight = dd.scrollHeight + 'px';
		dd.style.height = fullHeight;
	} );

	// 言語選択
	const langElement = document.getElementById( 'lang' );
	const ddElement = langElement.nextElementSibling;
	langElement.addEventListener( 'click', function () {
		this.classList.toggle( 'open' );
		// クラスの付与・削除を切り替え
		ddElement.classList.toggle( 'open' );
	} );

	// SPハンバーガーメニュー
	const navToggle = document.getElementById( 'navToggle' );
	const headerNavElement = document.querySelector( '.headerNav' );
	const body = document.body;
	navToggle.addEventListener( 'click', function () {
		this.classList.toggle( 'open' );
		headerNavElement.classList.toggle( 'active' );
		// メニューが開いたら body にクラスを付与してスクロールを無効化
		if ( this.classList.contains( 'open' ) ) {
			body.classList.add( 'no-scroll' );
		} else {
			body.classList.remove( 'no-scroll' );
		}
	} );

	// グローバルメニュー サブナビゲーション
	const subJsElement = document.getElementById( 'subJs' );
	const subJsddElement = subJsElement.nextElementSibling;
	subJsElement.addEventListener( 'click', () => {
		subJsddElement.classList.toggle( 'open' );
		subJsElement.parentElement.classList.toggle( 'open' );
	} );

	// カウントアップ処理
	function countUp( element, duration ) {
		const targetNum = parseInt( element.getAttribute( 'data-num' ) ); // data-numから最終値を取得
		const startNum = 0; // 初期値
		const increment = targetNum / ( duration / 16 ); // フレーム毎の増加値を計算 (約60FPS)

		let currentNum = startNum;
		const interval = setInterval( () => {
			currentNum += increment;
			if ( currentNum >= targetNum ) {
				currentNum = targetNum; // 最終値を設定
				clearInterval( interval ); // カウント終了
			}
			element.innerText = Math.floor( currentNum ); // 数値を更新
		}, 16 ); // 16msごとに実行（約60FPS）
	}
	// 全ての .number 要素を取得して、カウントアップを適用
	function handleIntersect( entries, observer ) {
		entries.forEach( ( entry ) => {
			if ( entry.isIntersecting ) {
				const numberElements =
					entry.target.querySelectorAll( '.number' );
				numberElements.forEach( ( element, index ) => {
					setTimeout( () => {
						countUp( element, 500 );
					}, index * 100 );
				} );
				observer.unobserve( entry.target ); // 一度実行したら再実行しないように解除
			}
		} );
	}

	// IntersectionObserverの設定
	const options = {
		root: null, // ビューポートを基準にする
		rootMargin: '0px',
		threshold: 0.5, // 要素が画面の1/3に達したら
	};
	const observer = new IntersectionObserver( handleIntersect, options );
	// すべての .card 要素を監視
	const cardElements = document.querySelectorAll( '.card' );
	cardElements.forEach( ( card ) => {
		observer.observe( card ); // 各 .card を監視
	} );

	const srcToTop = document.getElementById( 'srcToTop' );

	// スクロールイベントの監視
	window.addEventListener( 'scroll', () => {
		if ( window.scrollY > 150 ) {
			srcToTop.classList.add( 'visible' );
		} else {
			srcToTop.classList.remove( 'visible' );
		}
	} );

	// クリックでトップにスクロール
	srcToTop.addEventListener( 'click', () => {
		window.scrollTo( {
			top: 0,
			behavior: 'smooth',
		} );
	} );

	let animation;
	// アニメーションを初期化
	animation = lottie.loadAnimation( {
		container: document.getElementById( 'lottie-container' ), // 表示するコンテナのID
		renderer: 'svg', // SVGレンダリングを使用
		loop: false, // 全体のループはオフ
		autoplay: true, // 自動再生
		animationData: animationData, // JSONデータ
	} );

	// アニメーション終了時に75～159をループ再生
	animation.addEventListener( 'complete', () => {
		// 75から159フレームのループ再生を開始
		animation.playSegments( [ 75, 250 ], true );
	} );

	const sections = document.querySelectorAll(
		'.repeatlayouts .inner .repeatSection'
	);
	let shouldBeGray = false;

	sections.forEach( ( section ) => {
		// 全てのbgColorクラスを一旦削除（初期化）
		section.classList.remove( 'bgColor' );

		// cardクラスを持っている場合
		if ( section.classList.contains( 'card' ) ) {
			shouldBeGray = false;
			return;
		}

		// cardクラスの直後の要素の場合
		if ( section.previousElementSibling?.classList.contains( 'card' ) ) {
			shouldBeGray = true;
			return;
		}

		// 背景色が必要な要素にbgColorクラスを付与
		if ( shouldBeGray ) {
			section.classList.add( 'bgColor' );
		}

		shouldBeGray = ! shouldBeGray;
	} );

	// ページ内リンクを全て取得
	const links = document.querySelectorAll( 'a[href^="#"]' );

	links.forEach( ( link ) => {
		link.addEventListener( 'click', function ( e ) {
			e.preventDefault();

			// リンクのhref属性を取得
			const href = link.getAttribute( 'href' );

			// スクロール先の要素を取得
			const target = document.querySelector( href );

			if ( target ) {
				// ヘッダーの高さを取得（例：headerというクラス名の場合）
				const headerHeight =
					document.querySelector( 'header' ).offsetHeight;

				// 要素の位置を取得し、ヘッダーの高さを考慮
				const position =
					target.getBoundingClientRect().top +
					window.pageYOffset -
					headerHeight;

				// スムーズスクロール
				window.scrollTo( {
					top: position,
					behavior: 'smooth',
				} );
			}
		} );
	} );
} );
